import React from 'react'
import Lottie from 'react-lottie';
import animationData from './meditate.json';

const LottieCustomize = () => {
    const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
 
    return (
      <div>
        <Lottie 
          options={defaultOptions}
          height={300}
          width={300}
          isClickToPauseDisabled={true} 
        />
      </div>
    )
}

export default LottieCustomize;

 